import clsx from 'clsx';
import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

interface SecurityMethodCardProps {
  icon: LucideIcon;
  title: string;
  isEnabled: boolean;
  description: string;
  children: ReactNode;
}

/** One second-factor method on the Security page: what it is, whether it's on, and its actions underneath. */
export function SecurityMethodCard({ icon: Icon, title, isEnabled, description, children }: SecurityMethodCardProps) {
  return (
    <section className="rounded-lg border border-line bg-surface p-6">
      <div className="flex items-start gap-3">
        <div className="grid size-9 shrink-0 place-items-center rounded-lg bg-primary/10 text-primary ring-1 ring-primary/20">
          <Icon className="size-4.5" />
        </div>
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-2">
            <h2 className="text-base font-semibold text-fg">{title}</h2>
            <span className={clsx('rounded-full px-2 py-0.5 text-xs font-medium', isEnabled ? 'bg-success/10 text-success' : 'bg-muted/10 text-muted')}>
              {isEnabled ? 'On' : 'Off'}
            </span>
          </div>
          <p className="mt-1 text-sm text-muted">{description}</p>
        </div>
      </div>
      {children}
    </section>
  );
}
